import React, { useState, useEffect, Fragment, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Numeral from "react-numeral";
import { Primary } from "../../../components/buttons/Primary";
import {
  ArrowLongRightIcon,
  ArrowTrendingUpIcon,
  DocumentTextIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import { HttpRequest } from "../../../services/httpRequest";
import { SkeletonDahsboard } from "../../../components/skeleton/skeletonDash";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { ModalAgreeLocation } from "../../../components/modals/agreeLocation";
import { UtilsService } from "../../../services/credits/utils.service";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { SecondaryCard } from "../../../components/buttons/SecondaryCard";
import { useCredit } from "../../../context/creditContext";
import { creditStatus } from "../../flujo/Utils";
import { RewardsViewContext } from "../../../context/Disclosures/rewards/rewardsContext";

export function RenovarPage() {
  const { updateRewardsView } = useContext(RewardsViewContext);
  const navigate = useNavigate();
  const { disclosures, creditInfo, due } = useCredit();
  const [cupoDisponible, setCupoDisponible] = useState("");
  const [cupoAprobado, setCupoAprobado] = useState("");
  const [cupoUtilizado, setCupoUtilizado] = useState("");
  const [creditsInfo, setCreditsInfo] = useState({});
  const [basicInfo, setBasicInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [costs, setCosts] = useState([]);

  const loadCreditById = async () => {
    try {
      const data = await HttpRequest.getCreditById(
        localStorage.getItem("credit_id")
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const loadInfoUser = async () => {
    try {
      const data = await HttpRequest.getInfoUser(localStorage.getItem("doc"));
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const loadInfoQuota = async () => {
    try {
      const data = await HttpRequest.getQuotaStatus(
        localStorage.getItem("doc")
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpenDisclosure = () => {
    updateRewardsView({
      openDisclosure: true,
    });
  };

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    const loadInfo = async () => {
      let info = await loadInfoUser();
      return info;
    };

    const loadQuotaStatus = async () => {
      let quotaStatus = await loadInfoQuota();
      return quotaStatus;
    };

    const _loadCreditById = async () => {
      let credit = await loadCreditById();
      return credit;
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          try {
            let cupo = await loadQuotaStatus();
            let creditInfo = await _loadCreditById();
            if (!creditInfo) {
              return navigate("/formulariouno");
            }
            if (creditInfo?.status === creditStatus.PF || creditInfo?.status === creditStatus.S) {
              return navigate("/oferta");
            }
            setCreditsInfo(creditInfo);
            setCupoDisponible(cupo?.cupoDisponible);
            setCupoAprobado(cupo?.cupoAprobado);
            setCupoUtilizado(cupo?.cupoUtilizado);
            let infoUser = await loadInfo();
            setBasicInfo(infoUser);
            let costs = [
              { item: "Cupo aprobado", value: cupo?.cupoAprobado ?? 0 },
              {
                item: "Deuda a la fecha",
                value:
                  creditInfo?.status !== "Vigente"
                    ? 0
                    : creditInfo?.paymentBalance ?? 0,
              },
            ];
            setCosts(costs);
            setIsLoading(false);
          } catch (error) {
            console.log(error);
            return;
          }
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <Fragment>
        <DashboardMyCredit
          name={"Cargando"}
          balance={""}
          current={"3"}
          title={"Consultar cupo"}
          main={
            <>
              <div className="pt-10 mt-10 md:mt-0 pb-32 md:pb-0 bg-white md:bg-transparent rounded-t-3xl">
                <div className="md:mx-8 xl:mx-16 px-8 py-10 bg-white md:shadow-lg shadow-none rounded-2xl">
                  <div className="px-4">
                    <div className="block pt-6">
                      <SkeletonDahsboard height={20} width={100} />
                      <SkeletonDahsboard height={20} width={70} />
                    </div>
                    <div className="block pt-6">
                      <SkeletonDahsboard height={20} width={110} />
                      <SkeletonDahsboard height={20} width={70} />
                      <SkeletonDahsboard height={20} width={200} />
                      <SkeletonDahsboard height={30} width={40} />
                    </div>
                    <div className="block pt-6">
                      <SkeletonDahsboard height={20} width={100} />
                      <SkeletonDahsboard height={40} width={120} />
                    </div>
                    <div className="grid pt-6 justify-center">
                      <div className="flex gap-2 pt-8 justify-center">
                        <div className="pb-2 sm:pb-0">
                          <SkeletonDahsboard height={50} width={150} />
                        </div>
                      </div>
                      <div className="flex xl:hidden gap-2 text-sm pt-2">
                        <div className="grid justify-center w-full">
                          <div className="bg-purpleLight w-8 h-8 grid content-center justify-center rounded-full mx-auto">
                            <SkeletonDahsboard
                              variant={"circular"}
                              height={20}
                              width={20}
                            />
                          </div>
                          <SkeletonDahsboard height={15} width={60} />
                        </div>
                        <div className="grid justify-center w-full">
                          <div className="grid justify-center w-full">
                            <div className="bg-purpleLight w-8 h-8 grid content-center justify-center rounded-full mx-auto">
                              <SkeletonDahsboard
                                variant={"circular"}
                                height={20}
                                width={20}
                              />
                            </div>
                            <SkeletonDahsboard height={15} width={60} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <DashboardMyCredit
        name={basicInfo?.firstname}
        current={"3"}
        balance={
          creditsInfo?.status === "Cancelado" ? 0 : creditsInfo?.paymentBalance
        }
        title={"Consultar cupo"}
        disclosures={disclosures}
        creditInfo={creditInfo}
        due={due}
        main={

            <>
              <div className="pt-10 mt-10 md:mt-0 pb-32 md:pb-0 bg-white md:bg-transparent rounded-t-3xl">
                <div className="md:mx-8 xl:mx-16 px-8 py-10 bg-white md:shadow-lg shadow-none rounded-2xl">
                  <div className="px-4">
                    {costs.map((cost, index) => (
                      <div key={index} className="block pt-6">
                        <span className="block text-grayP">{cost.item} </span>
                        <Numeral
                          className="text-2xl font-bold"
                          format={"$0,0"}
                          value={cost.value === 0 ? "$0" : cost.value}
                        />
                      </div>
                    ))}
                    {creditsInfo?.status && creditsInfo.status === "Vigente" ? (
                      <>
                        <div className="text-sm text-grayP flex gap-1">
                          Fecha límite de pago{" "}
                          <div className="font-bold text-tdark">
                            {creditsInfo?.paydayLimit}
                          </div>
                        </div>
                        <a href="/pagar" className="pt-2">
                          <SecondaryCard text={"Pagar"} />
                        </a>
                      </>
                    ) : (
                      <div className="text-sm text-grayP flex gap-1">
                        No tienes deudas pendientes.
                      </div>
                    )}
                  </div>

                  <div>
                    <div className="px-4 pt-6">
                      <span className="block text-grayP">Cupo disponible</span>
                      <Numeral
                        className="text-2xl font-bold"
                        format={"$0,0"}
                        value={cupoDisponible}
                      />
                    </div>
                  </div>

                  <div className="flex gap-2 text-sm pt-6">
                    <div className="grid justify-center w-full">
                      <a
                        onClick={handleOpenDisclosure}
                        href="#"
                        className="bg-purpleLight w-8 h-8 grid content-center justify-center rounded-full mx-auto"
                      >
                        <ArrowTrendingUpIcon className="w-6 h-auto" />
                      </a>
                      Cómo aumentar mi cupo
                    </div>
                  </div>

                  {cupoDisponible === "0" ||
                  cupoDisponible === 0 ||
                  creditsInfo?.status === "Vigente" ? (
                    <div></div>
                  ) : (
                    <div className="grid pt-10 justify-center">
                      <Link
                        to={"/renovar/confirmar"}
                        state={{
                          doc: creditsInfo?.documento,
                          name: basicInfo?.firstname,
                          amount:
                            creditsInfo.status === "Cancelado"
                              ? 0
                              : creditsInfo.paymentBalance,
                        }}
                      >
                        <Primary
                          text={"Solicitar ahora"}
                          icon={<ArrowLongRightIcon className="w-6 h-auto" />}
                        />
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </>
        }
      />
    </Fragment>
  );
}
